import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="bottom-right"
      expand={true}
      richColors={false}
      closeButton={true}
      duration={4000}
      gap={8}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-card-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl group-[.toaster]:px-4 group-[.toaster]:py-3 group-[.toaster]:animate-slide-in-right",
          title: "group-[.toast]:font-semibold group-[.toast]:text-sm",
          description: "group-[.toast]:text-muted-foreground group-[.toast]:text-sm",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:font-medium group-[.toast]:rounded-lg",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:rounded-lg",
          closeButton: "group-[.toast]:!bg-transparent group-[.toast]:!border-0 group-[.toast]:!shadow-none group-[.toast]:text-current group-[.toast]:opacity-60 hover:group-[.toast]:opacity-100 group-[.toast]:!right-1 group-[.toast]:!top-1 group-[.toast]:!left-auto group-[.toast]:!transform-none group-[.toast]:!static group-[.toast]:!ml-auto group-[.toast]:!-mr-1 group-[.toast]:!-mt-0.5",
          success: "group-[.toaster]:!bg-emerald-50 group-[.toaster]:!border-emerald-200 group-[.toaster]:!text-emerald-800 dark:group-[.toaster]:!bg-emerald-950/30 dark:group-[.toaster]:!border-emerald-800 dark:group-[.toaster]:!text-emerald-200",
          error: "group-[.toaster]:!bg-red-50 group-[.toaster]:!border-red-200 group-[.toaster]:!text-red-800 dark:group-[.toaster]:!bg-red-950/30 dark:group-[.toaster]:!border-red-800 dark:group-[.toaster]:!text-red-200",
          warning: "group-[.toaster]:!bg-amber-50 group-[.toaster]:!border-amber-200 group-[.toaster]:!text-amber-800 dark:group-[.toaster]:!bg-amber-950/30 dark:group-[.toaster]:!border-amber-800 dark:group-[.toaster]:!text-amber-200",
          info: "group-[.toaster]:!bg-primary/10 group-[.toaster]:!border-primary/30 group-[.toaster]:!text-primary",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };

